import { createSlice } from '@reduxjs/toolkit'
import { getMailMappersPag} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  mailMappersPag: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: []
  },
  loading: "idle",
  error: null }

const mailMappersSlice = createSlice({
  name: 'mailMappers',
  initialState,
  reducers: {
      clearMailMappersError: (state)=>{
          state.error = null
          state.loading = "idle"
    }
  },
  extraReducers: {
      [getMailMappersPag.pending]: (state) => {
          state.loading = "loading"; 
          state.error = null
      },
      [getMailMappersPag.fulfilled]: (state, action) => {
          state.loading = "succeeded";
          state.mailMappersPag.elements = action.payload.elements
          state.mailMappersPag.pageIndex = action.payload.pageIndex;
          state.mailMappersPag.totalRecords = action.payload.totalRecords;
          state.mailMappersPag.pageSize = action.payload.pageSize;
          state.mailMappersPag.totalPages = action.payload.totalPages;
          state.mailMappersPag.hasPreviousPage = action.payload.hasPreviousPage;
          state.mailMappersPag.hasNextPage = action.payload.hasNextPage
      
    },
      [getMailMappersPag.rejected]: (state, action) => {
          state.loading = "failed"; 
          state.error = action.error.message
      },
      [logOut]: (state)=> initialState
  }
})

export const {clearMailMappersError} = mailMappersSlice.actions;
export default mailMappersSlice.reducer
